export interface FilterOption {
  id: number;
  name: string;
  description?: string | null;
  min_age?: number;
  max_age?: number;
  code?: string;
}

export interface FilterOptions {
  Demographics: {
    gender: FilterOption[];
    ageInterval: FilterOption[];
    ethnicity: FilterOption[];
  };
  Lifestyle: {
    lifestyle: FilterOption[];
    statusClass: FilterOption[];
    industry: FilterOption[];
  };
  Location: {
    continent: FilterOption[];
  };
  'NBA Preferences': {
    favoritePlayers: Array<
      FilterOption & {
        city_id: number;
        city: string;
        team_id: number;
        team: string;
      }
    >;
  };
}

export const filterService = {
  async getFilters(): Promise<FilterOptions> {
    // Desactivado - retorna dados vazios
    return {
      Demographics: {
        gender: [],
        ageInterval: [],
        ethnicity: [],
      },
      Lifestyle: {
        lifestyle: [],
        statusClass: [],
        industry: [],
      },
      Location: {
        continent: [],
      },
      'NBA Preferences': {
        favoritePlayers: [],
      },
    };

    /*
    try {
      const response = await httpClient.get<FilterOptions>('/api/dashboard/get-filters', {
        headers: {
          'hoopers-api-key': import.meta.env.VITE_API_KEY,
          Accept: 'application/json',
          'Cache-Control': 'no-cache',
        },
        withCredentials: true,
      });
      return response;
    } catch (error) {
      console.error('Failed to fetch filters:', error);
      // Return empty objects for each filter category if the request fails
      return {
        Demographics: {
          gender: [],
          ageInterval: [],
          ethnicity: [],
        },
        Lifestyle: {
          lifestyle: [],
          statusClass: [],
          industry: [],
        },
        Location: {
          continent: [],
        },
        'NBA Preferences': {
          favoritePlayers: [],
        },
      };
    }
    */
  },
};
